// extracted by mini-css-extract-plugin
export default {"chat_list":"chat-list_chat_list__UE63C","list":"chat-list_list__lIsPX","chat_gradient":"chat-list_chat_gradient__6hs77"};